import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditSortNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditSortNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditSortNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
       data_input: {
            title: 'Data Input',
            type: 'string',
           description: 'Value to sort'
       },
        input_key: {
           title: 'Input Key',
            type: 'string',
            description: 'Key of data to extract if applicable. Use value_one/value_two for nested data',
        },
        sort_type: {
           title: "Sort Type",
            type: 'string',
            enum: [
                'Ascending',
                'Descending',
            ],
            default: 'Ascending'
        },
        sort_options: {
           title: 'Sort Options',
            type: 'object',
            properties: {
                'sort_by': {
                    title: 'Sort By',
                    type: 'string',
                    enum: [
                        'Default',
                        'Value Length',
                        'Custom Key',
                    ],
                    default: 'Default',
                    description: 'Value Length works on string arrays and custom key works on key/value arrays'
                },
                custom_key: {
                    title: 'Custom Key',
                    type: 'string',
                    description: 'Key to sort by if applicable',
                }
            }
        },
        data_management: {
            title: 'Data Store',
            type: 'string',
            description: 'Where to store sorted value',
            default: 'default'
        },
    },
}

export const nodeDescription: string = "This node is used to sort a data array." +
    "The newly sorted data is then saved to the Data Store Slot.\n";